export default {
    1: '现金',
    2: '微信',
    3: '支付宝',
    4: '余额'
}
